<template>
    <v-data-table
        :fixed-header="true"
        :headers="headers"
        :hover="true"
        :item-key="(item) => `row-${item.id}`"
        :items="devices"
        :items-per-page="10"
        class="elevation-1"
        density="compact"
        item-value="id"
    >
        <template v-slot:item.id="{ item }">
            <td :class="`item-${item.value}`">{{ item.value }}</td>
        </template>
        <!-- 'voltage' is the SKU-selected channel in millivolts; phones carry a percent. -->
        <template v-slot:item.voltage="{ item }">{{ batteryLevelText(item) }}</template>
    </v-data-table>
</template>

<script setup>
import {watch} from "vue";
import {batteryLevelText} from "@/composables/usePowerSourceIcon";

const props = defineProps(['devices', 'headers', 'selected']);

const blinkElementById = (id) => {
    const elem = document.querySelector(`.item-${id}`);
    // The row, not the cell: the class was added to the tr and removed from the
    // td, so it was never cleared. And the timeout sat outside the null check,
    // so a missing element threw two seconds later, far from the cause.
    const row = elem?.closest('tr');
    if (!row) return;
    row.classList.add('blinking-row')

    setTimeout(() => row.classList.remove('blinking-row'), 2000)
}

watch(() => props.devices, (val) => {
    val.forEach((device) => {
        if (device.diff_in_secs < 10) {
            blinkElementById(device.id)
        }
    })
})

watch(() => props.selected, (val) => {
    blinkElementById(val)
})
</script>

<style scoped>

</style>
